import Icon from 'veui/components/Icon'

Icon.register({
  'arrow-left': {
    paths: [
      {
        d: 'M19.89 42.66L2.64 25.41a2 2 0 01-.12-2.7l.12-.12L19.89 5.34a2 2 0 012.94 2.7l-.12.12L8.83 22.05h35.22a2 2 0 012 1.85v.15a2 2 0 01-1.85 2H8.93L22.7 39.84a2 2 0 01.12 2.7l-.12.12a2 2 0 01-2.7.12l-.12-.12L2.64 25.41l17.25 17.25z'
      }
    ],
    width: '48',
    height: '48'
  }
})
